(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.onlineres', {
                parent: 'tables',
                url: '/online-res',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/online-res/online-res.html',
                        controller: 'OnlineListReservationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
